import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CompanyInput from "../../Inputs/CompanyInput/CompanyInput";
import { useDispatch, useSelector } from "react-redux";
import notify from "../../../hooks/useNotifaction";
import {
  createCompany,
  getAllCompanies,
} from "../../../redux/companySlice/companySlice";

export default function AddCompany({ handleNewCompany }) {
  const location = useLocation();
  const isAddCompanyPage = location.pathname.endsWith("/AddCompany");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [companyData, setCompanyData] = useState({
    companyName: "",
    email: "",
    state: "",
    city: "",
    location: "",
    address: "",
    phone: "",
    commercialRecord: "123213213",
    taxNumber: "213123123",
  });

  const [fieldErrors, setFieldErrors] = useState({});

  const handleInputChange = (name, value) => {
    setCompanyData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error for this field when user starts typing
    if (fieldErrors[name]) {
      setFieldErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validateForm = () => {
    const errors = {};
    const { companyName, state, city, address } = companyData;

    if (!companyName?.trim()) {
      errors.companyName = "يرجى إدخال اسم الشركة";
    }

    if (!state?.trim()) {
      errors.state = "يرجى إدخال الحالة";
    }

    if (!city?.trim()) {
      errors.city = "يرجى إدخال المدينة";
    }

    if (!address?.trim()) {
      errors.address = "يرجى إدخال العنوان";
    }

    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  async function handleForm(e) {
    e.preventDefault();
    if (!validateForm()) {
      notify("يرجى ملء جميع الحقول المطلوبة", "error");
      return;
    }

    try {
      // بنرسل فقط الحقول المطلوبة
      let companyPayload = {
        name: companyData.companyName,
        state: companyData.state,
        address: companyData.address,
        city: companyData.city,
      };

      // إضافة الحقول الاختيارية إذا كانت مملوءة
      if (companyData.email?.trim()) {
        companyPayload.email = companyData.email;
      }
      if (companyData.phone?.trim()) {
        companyPayload.phone = companyData.phone;
      }
      if (companyData.location?.trim()) {
        companyPayload.location = companyData.location;
      }
      if (companyData.commercialRecord?.trim()) {
        companyPayload.commercial_record = companyData.commercialRecord;
      }
      if (companyData.taxNumber?.trim()) {
        companyPayload.tax_number = companyData.taxNumber;
      }

      let res = await dispatch(createCompany(companyPayload)).unwrap();
      notify("تمت إضافة الشركة بنجاح", "success");

      if (isAddCompanyPage) {
        navigate("/companies");
      } else {
        handleNewCompany();
      }

      await dispatch(getAllCompanies());

      setCompanyData({
        companyName: "",
        email: "",
        state: "",
        city: "",
        location: "",
        address: "",
        phone: "",
        commercialRecord: "123213213",
        taxNumber: "213123123",
      });
      setFieldErrors({});
    } catch (error) {
      console.log(error);

      // معالجة أخطاء الحقول من الـ backend
      if (error?.errors && typeof error.errors === "object") {
        const errors = {};
        Object.keys(error.errors).forEach((key) => {
          errors[key] = error.errors[key];
        });
        setFieldErrors(errors);
      }

      notify(error?.message || "حدث خطأ في إضافة الشركة", "error");
    }
  }

  return (
    <div className={isAddCompanyPage ? "main" : ""}>
      {isAddCompanyPage && <h2 className="text-white mb-4">اضافة شركة</h2>}
      <form onSubmit={handleForm}>
        <div
          className={
            isAddCompanyPage
              ? "card mb-3 pt-5 pb-2 px-3 companyProfile"
              : "mb-3 pt-5 pb-2 px-3 companyProfile"
          }
        >
          <CompanyInput
            companyData={companyData}
            onInputChange={handleInputChange}
            fieldErrors={fieldErrors}
          />
          <div>
            <button type="submit" className="btn btn-primary">
              <i className="fas fa-plus me-1"></i> اضافة
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
